<template>
  <div class="matrix-fill">
    <q-table ref="table" :view="view" :columns="issue.items" :rows="issue.rows" :row-desc="issue.rowDesc" :widths="issue.widths">
      <template v-slot:content="{ row, col }">
        <fill
          :option="issue.getCellByRowAndCol(row, col)"
          :question-type="question.questionType"
          :question-id="question.id"
          :question="question"
          :enable-relation="issue.setting.enableRelation"
          :disable-copy="issue.disableCopy"
        />
      </template>
    </q-table>
  </div>
</template>

<script>
import MatrixTable from '@/questions/components/MatrixTable'
import Fill from '@/questions/components/Fill'
import QTable from '@/questions/components/QTable'

export default {
  name: 'MatrixFill',
  components: { QTable, Fill, MatrixTable },
  changeExpr: 'changeExpr',
  computed: {
    changeExpr() {
      return this.issue.cells
        .map(i => i.value)
        .filter(Boolean)
        .join('-')
    }
  },
  watch:{
    'question.questionErrorList'(){
      this.$nextTick(()=>{
        this.$refs.table.initTable()
      })
    }
  }
}
</script>
